import { type OfferProps } from './contractToProps';

export const clickOut = (analyticsDataLayer: unknown[], offer: OfferProps, index: number, fullPageUrl: string) => {
  analyticsDataLayer.push({
    action: 'offers_clickout',
    bookieCode: offer.bookie,
    category: 'Widget',
    event: 'offer_clickouts',
    label: 'claim_offer',
    offerIndex: index + 1,
    offerName: offer.heading,
    page: fullPageUrl,
    variation: 'horizontal-slim',
  });
};

export const impression = (
  analyticsDataLayer: unknown[],
  analyticsImpressionEventData: Record<string, unknown>,
  fullPageUrl: string,
) => {
  analyticsDataLayer.push({
    action: 'impression',
    category: 'Widget',
    event: 'widget_impression',
    label: 'widget_impression',
    page: fullPageUrl,
    variation: 'horizontal-slim',
    widgetType: 'offers',
    ...(analyticsImpressionEventData ?? {}),
  });
};
